
//Kindly use https://mpgpsr-qa.spe.sony.com/app/api/getUserDetails respones here before running application in bypassOktaForLocal mode
//Whereever you point db user that enviroment api response

export const dummyUser =
 {
    "status": "SUCCESS",
    "errorCode": null,
    "errorDescription": null,
    "serviceResponseDescription": null,
    "serviceIdentifier": null,
    "remark": null,
    "created": null,
    "serviceResult": {
        "mpgpsrUserId": 123,
        "firstName": "Nilam",
        "lastName": "Bhalerao",
        "middleInitial": null,
        "speId": "nbhalerao",
        "email": "Nilam_Bhalerao@spe.sony.com",
        "userRole": {
            "roleId": 1,
            "roleName": "Super Admin",
            "sectionPermissions": [
                {
                    "roleScreenPermissionMappingId": 10,
                    "roleId": 1,
                    "sectionId": 10,
                    "permissionId": 38,
                    "sectionName": "Key Issues (Project Information)",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 3,
                    "roleId": 1,
                    "sectionId": 3,
                    "permissionId": 38,
                    "sectionName": "Net Potentials",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 21,
                    "roleId": 1,
                    "sectionId": 21,
                    "permissionId": 38,
                    "sectionName": "Post-Production Summary Report",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 6,
                    "roleId": 1,
                    "sectionId": 6,
                    "permissionId": 38,
                    "sectionName": "Budget Lock/Unlock",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 7,
                    "roleId": 1,
                    "sectionId": 7,
                    "permissionId": 38,
                    "sectionName": "Cost to Date, FX (G)/L",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 11,
                    "roleId": 1,
                    "sectionId": 11,
                    "permissionId": 38,
                    "sectionName": "Key Dates",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 197,
                    "roleId": 1,
                    "sectionId": 23,
                    "permissionId": 38,
                    "sectionName": "Post-Production Admin",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 14,
                    "roleId": 1,
                    "sectionId": 14,
                    "permissionId": 38,
                    "sectionName": "Search",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 19,
                    "roleId": 1,
                    "sectionId": 19,
                    "permissionId": 38,
                    "sectionName": "Post-Production Schedule",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 5,
                    "roleId": 1,
                    "sectionId": 5,
                    "permissionId": 38,
                    "sectionName": "Key Issues",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 9,
                    "roleId": 1,
                    "sectionId": 9,
                    "permissionId": 38,
                    "sectionName": "Key Crew",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 4,
                    "roleId": 1,
                    "sectionId": 4,
                    "permissionId": 38,
                    "sectionName": "Weekly Variance",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 12,
                    "roleId": 1,
                    "sectionId": 12,
                    "permissionId": 38,
                    "sectionName": "Schedule",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 17,
                    "roleId": 1,
                    "sectionId": 17,
                    "permissionId": 38,
                    "sectionName": "Weekly Variance Report",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 2,
                    "roleId": 1,
                    "sectionId": 2,
                    "permissionId": 38,
                    "sectionName": "Net Cost Summary",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 15,
                    "roleId": 1,
                    "sectionId": 15,
                    "permissionId": 38,
                    "sectionName": "Admin",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 18,
                    "roleId": 1,
                    "sectionId": 18,
                    "permissionId": 38,
                    "sectionName": "Key Information",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 1,
                    "roleId": 1,
                    "sectionId": 1,
                    "permissionId": 38,
                    "sectionName": "Budget",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 20,
                    "roleId": 1,
                    "sectionId": 20,
                    "permissionId": 38,
                    "sectionName": "Picklist Admin",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 192,
                    "roleId": 1,
                    "sectionId": 22,
                    "permissionId": 38,
                    "sectionName": "Schedule (POST row)",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 16,
                    "roleId": 1,
                    "sectionId": 16,
                    "permissionId": 38,
                    "sectionName": "Production Status Report",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 8,
                    "roleId": 1,
                    "sectionId": 8,
                    "permissionId": 38,
                    "sectionName": "Publish & Roll back",
                    "permissionName": "READ/WRITE"
                },
                {
                    "roleScreenPermissionMappingId": 13,
                    "roleId": 1,
                    "sectionId": 13,
                    "permissionId": 38,
                    "sectionName": "Home",
                    "permissionName": "READ/WRITE"
                }
            ],
            "description": null,
            "wednesdayAccessFlag": false,
            "createdBy": "admin",
            "createdDate": "2023-03-03T00:00:00",
            "modifiedBy": "sjaiswal",
            "modifiedDate": "2023-03-03T00:00:00"
        },
        "departmentId": 142,
        "activeFlag": true,
        "speEmployeeFlag": true,
        "lastLoginDate": "2025-12-02",
        "userAccessibleStudioIds": [
            47,
            48,
            49,
            50,
            53,
            54,
            55,
            null,
            130
        ],
        "roleId": 1,
        "roleName": "Super Admin",
        "departmentName": "All Departments",
        "wednesdayAccessFlag": false
    },
    "isRefreshNeeded": null
};